<div class="attachment-move-dialog">
  <div class="flex flex-row  justify-between">
    <div class="left">
      <h3>Select {{action_type_config_list[currentStep].description}} Type</h3>
    </div>
    <div class="right">
      <button mat-icon-button (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <mat-divider class="mt-6 pr-6"    style="margin: 0 -24px;"  ></mat-divider>
  <form>
    <mat-form-field appearance="fill" style="margin: 12px 0px; width: -webkit-fill-available" class="form_input file-search" id="myfield">
      <mat-icon style="color: #707070" matSuffix>search </mat-icon>
      <input
        style="position: relative;top: -6px;left: 4px;"
        #accountInput
        type="text"
        matInput
        aria-label="Number"
        [formControl]="associationForm"
        placeholder="{{ 'Search ' + action_type_config_list[currentStep].description  }} "
        id="search_input"
        />
        {{ accountInput.focus() }}
      </mat-form-field>

    </form>
    <div class="attachment-move-dialog__content flex flex-wrap my-3  max-h-80 overflow-y-auto" >
      @for (item of searchList; track item; let i = $index) {
        <div>
          <div
            (click)="handleFolderSelected(item,i)"
            (mouseenter)="item.selected=true"
            (mouseleave)="item.selected=false"
            class="app__discovery-vault-form-options mb-3 mr-3"
            style="width: 180px !important;"
              [ngClass]="{
                  ' bg-[#EFFFF7] border-[#1AA140]': item.selected,
                  ' hover:rounded-xl hover:bg-white hover:border-2 hover:border-solid hover:border-[#25508E] hover:cursor-pointer': !item.selected
                }"
            >
            <img src="{{ !item.selected ? item.image : 'assets/images/discovery/selected.svg' }}" alt="" />
            <p class="app__discovery_vault_form-title">
              {{ item.type }}
            </p>
          </div>
        </div>
      }

    </div>

  </div>